export const getYear = (val) => {
  if (!val) return null;
  const d = new Date(val);
  return Number.isNaN(d) ? null : d.getFullYear();
};
